export default [
  {
    path: '/admin/stock-confirm',
    name: 'stock-confirm',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-confirm/index.vue')
  },
  {
    path: '/admin/stock-confirm/:id/stock-ins',
    name: 'stock-confirm-stock-in',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/stock/stock-confirm/view-confirm-stock-in.vue')
  },
  {
    path: '/admin/stock-confirm/:id/write-offs',
    name: 'stock-confirm-write-off',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/stock/stock-confirm/view-confirm-write-off.vue')
  }
]
